import Quiz1Screen from "@components/Onboarding/Intro/Quiz1Screen";
import { useAuth } from "@utils/firebaseAuth/auth";
import { Redirect } from "expo-router";

export default function OnboardingScreen() {
  const { onboardingStep } = useAuth();

  if (onboardingStep === "email_verification_pending") {
    return <Redirect href="/auth/verify-email" />;
  }

  return <Quiz1Screen />;
}
